import AccessDenied from "./components/AccessDenied";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import User from "./pages/User";
import Projects from "./pages/Projects";
import Layout from "./components/navbarComp/layout";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 60 seconds
      gcTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

function Router() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Login />} />

      {/* Protected - all roles */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={["admin", "manager", "viewer"]}>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Admin & Manager */}
      <Route
        path="/projects"
        element={
          <ProtectedRoute allowedRoles={["admin", "manager", "viewer"]}>
            <Layout>
              <Projects />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Admin only */}
      <Route
        path="/users"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <Layout>
              <User />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route path="/access-denied" element={<AccessDenied />} />
    </Routes>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Router />
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            toastStyle={{
              backgroundColor: "white",
              color: "#000",
            }}
            progressClassName={{
              color: "white",
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
